import { Component, Input, TemplateRef, ViewChild } from '@angular/core';

@Component({
  selector: 'fz-conditional',
  templateUrl: './conditional.component.html',
  styleUrls: ['./conditional.component.scss'],
})
export class ConditionalComponent {
  @Input()
  loading!: boolean | null;

  @Input()
  error: boolean;

  @Input()
  loadingComponent: TemplateRef<any>;

  @Input()
  errorComponent: TemplateRef<any>;

  @Input()
  dataComponent: TemplateRef<any>;

  // defaults
  @ViewChild('defaultLoading', { read: TemplateRef })
  defaultLoading: TemplateRef<any>;

  @ViewChild('defaultError', { read: TemplateRef })
  defaultError: TemplateRef<any>;

  @ViewChild('defaultData', { read: TemplateRef })
  defaultData: TemplateRef<any>;

  get activeTemplate(): TemplateRef<any> {
    if (this.loading) {
      return this.loadingComponent;
    } else if (this.error) {
      return this.errorComponent;
    }

    return this.dataComponent;
  }
}
